module.exports = __webpack_public_path__ + "static/media/180819205640981.2e819b6c.png";